<div class="modal"
     [class.modal_large]="(isMobile$ | async) === false"
     [ngClass]="{'is-full': isShowFull}">
  <span class="modal__close ngdialog-close" (click)="$event.stopPropagation(); close()">
    <i class="material-icons">close</i>
  </span>
  <div class="modal-header">
    <div class="invoice__date" *ngIf="inputInvoice?.dateTime || inputInvoice?.DateTime">
      Створена: {{
        (inputInvoice?.dateTime | np_to_date_format | date :"dd.MM.yyyy HH:mm:ss")
        || (inputInvoice?.DateTime | np_to_date_format | date :"dd.MM.yyyy HH:mm:ss")
      }}
      <span *ngIf="invoice?.OwnerDocumentNumber"
            class="invoice__date-hint">{{ inputInvoice?.note }}</span>
    </div>
    <div class="invoice-header">
      <div class="invoice-header__left">
        <mat-icon *ngIf="type === 'out'" class="material-icons invoice-header__icon-type">call_made</mat-icon>
        <mat-icon *ngIf="type === 'in'" class="material-icons invoice-header__icon-type">call_received</mat-icon>
        <mat-icon *ngIf="type === 'arch-main'" class="material-icons invoice-header__icon-type">archive</mat-icon>
        <div class="invoice-header__number copy-content copy-content_lg">{{ formattedInvoiceNumber }}
          <button mat-icon-button class="copy-content__btn"
                  [appCopy]="invoice?.docNumber"
                  [matTooltip]="'Скопіювати'" matTooltipPosition="below">
            <mat-icon class="material-icons_grey copy-content__icon">content_copy</mat-icon>
          </button>
        </div>
        <np-share-invoice-state *ngIf="invoice"
                                [invoice]="invoice"
                                [backMoney]="backMoney"
                                [paymentControl]="paymentControl"
                                [contactPhone]="contactPhone"
                                class="share-invoice-state">
        </np-share-invoice-state>
      </div>
      <div class="invoice-header__right">
        <div class="invoice-header__info">
          <div class="info-cell invoice-header__cell">
            <div class="info-cell__label">Опис відправлення</div>
            <div class="info-cell__content"
                 [matTooltip]="inputInvoice?.CargoDescription"
                 matTooltipPosition="below">{{ inputInvoice?.CargoDescription || '&mdash;' }}
            </div>
          </div>
          <div class="info-cell invoice-header__cell">
            <div class="info-cell__label">Оголошена цінність</div>
            <div class="info-cell__content" *ngIf="inputInvoice?.announcedPrice;else dash">
              {{ getInvoiceAnnouncedPrice(inputInvoice) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <main class="modal-content modal-content_pad-none">
    <mat-progress-bar [style.opacity]="+(loading$ | async)" mode="indeterminate">
    </mat-progress-bar>
    <div class="invoice">
      <app-simple-banner *ngIf="(invoice?.deliveryPrice !== invoice?.SumBeforeCheckWeight && invoice?.SumBeforeCheckWeight > 0) || invoice?.CalculatedWeight > 0"
                         [type]="BannerType.Warning"
                         class="simple-banner">
        <ng-container title>Вагу відправлення змінено</ng-container>
        <ng-container text>
          <ng-container *ngIf="invoice?.CalculatedWeight > 0">
            За результатами контрольного зважування фактична вага вашої посилки була оновлена.
          </ng-container>
          <ng-container *ngIf="(invoice?.deliveryPrice !== invoice?.SumBeforeCheckWeight && invoice?.SumBeforeCheckWeight > 0)">
            У разі незгоди з результатом ви можете самостійно перезважити посилку в момент її отримання.
          </ng-container>
        </ng-container>
      </app-simple-banner>
      <div class="invoice-body">
        <div class="invoice-body__left">
          <app-invoice-progress-state *ngIf="invoice?.state"
                                      [stateColor]="invoice.state.color"
                                      [progressPercent]="invoice.state.progressPercent"
                                      [showNote]="invoice.state.showNote"
                                      [informerPosition]="invoice.state.informerPosition"
                                      [informerIcon]="invoice.state.informerIcon"
                                      [informerDate]="invoiceStateInformerDate"
                                      [informerText]="invoice.state.name"
                                      [startLocation]="inputInvoice?.SenderAddressDescription"
                                      [endLocation]="inputInvoice?.RecipientAddressDescription"
                                      [dateFirstDayStorage]="invoice?.dateFirstDayStorage"
                                      [dateReturnCargo]="invoice?.dateReturnCargo">
            <ng-container startPoint>
              Дата
              виїзду: {{ (inputInvoice?.dateTime | np_to_date_format| date :"dd.MM.yyyy") || (inputInvoice?.DateTime | np_to_date_format| date :"dd.MM.yyyy") }}
            </ng-container>

            <ng-container endPoint>
              <div
                *ngIf="invoice?.state?.id !== '4' && invoice?.state?.id !== '5' && invoice?.state?.id !== '0' && invoice?.state?.id !== '6'">
                Плановий час доставки: {{ invoice?.scheduleDeliveryDate | np_to_date_format | deliveryDate }}
              </div>
              <div *ngIf="invoice?.state?.id === '5' && inputInvoice?.receivingTime && invoice?.receivingTime">
                Дата
                отримання: {{ (inputInvoice?.receivingTime | np_to_date_format | date :"dd.MM.yyyy HH:mm:ss") || (invoice?.receivingTime | np_to_date_format | date :"dd.MM.yyyy HH:mm:ss") }}
              </div>
              <div *ngIf="!invoice?.state?.showNote && invoice?.state?.note">
                {{ invoice?.state?.note }}
              </div>
            </ng-container>

            <ng-container processInformer>
              <app-invoice-transport-process-informer
                [invoice]="getStatusDocumentsInvoice">
              </app-invoice-transport-process-informer>
            </ng-container>
          </app-invoice-progress-state>
        </div>
        <div class="invoice-body__right">
          <div>
            <div class="invoice-body__info">
              <div class="info-cell invoice-body__info-cell">
                <div class="info-cell__label">Отримувач</div>
                <div class="info-cell__content">
                  <ng-container
                    *ngIf="recipientCounterpartyType !== 'Приватна особа' && recipientCounterpartyType !== 'PrivatePerson'">
                    {{ inputInvoice?.CounterpartyRecipientDescription || '&mdash;' }}<br>
                  </ng-container>
                  {{ inputInvoice?.RecipientName || '&mdash;' }}
                </div>
              </div>
              <div class="info-cell invoice-body__info-cell">
                <div class="info-cell__label">Телефон отримувача</div>
                <div class="info-cell__content nowrap-text" *ngIf="contactPhone || invoice?.recipient?.phone">
                  <span class="nowrap copy-content">
                    {{ (contactPhone | npFinePhone) || (invoice?.recipient?.phone | npFinePhone) || '&mdash;' }}
                    <button mat-icon-button class="copy-content__btn"
                            [appPhoneCopy]="contactPhone || invoice?.recipient?.phone"
                            [matTooltip]="'Скопіювати'" matTooltipPosition="below">
                      <mat-icon class="material-icons_grey copy-content__icon">content_copy</mat-icon>
                    </button>
                  </span>
                </div>
                <div class="info-cell__content" *ngIf="!contactPhone && !invoice?.recipient?.phone">
                  &mdash;
                </div>
              </div>

              <div class="info-cell invoice-body__info-cell last"
                   *ngIf="inputInvoice?.RecipientFullName &&
                          inputInvoice?.RecipientFullName !== '' &&
                          inputInvoice?.receivingTime &&
                          inputInvoice?.receivingTime !== '0001-01-01 00:00:00' &&
                          inputInvoice?.statusCode !== '102' && inputInvoice?.statusCode !== '103' && inputInvoice?.statusCode !== '108'">
                <div class="info-cell__label">Отримав(ла)</div>
                <div class="info-cell__content">
                  {{ inputInvoice?.RecipientFullName || '&mdash;' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="invoice-services"
           *ngIf="showAdditionalServices">
        <div class="invoice-services__title">Додаткові послуги</div>

        <div class="invoice-services__item"
             *ngIf="inputInvoice.RedirectingReturnIndication && !redirectRequest && !returnRequest">
          <div class="invoice-services__name nowrap-text">
            <i class="material-icons invoice-services__icon">{{ inputInvoice.RedirectingReturnIndication.icon }}</i>
            <span>{{ inputInvoice.RedirectingReturnIndication.tooltipText }}</span>
          </div>
        </div>

        <div class="invoice-services__item wrap"
             *ngIf="inputInvoice.backDeliveryPayer && inputInvoice.backMoney">
          <div class="invoice-services__name nowrap-text">
            <i class="material-icons invoice-services__icon">reply</i>
            <span>Зворотна доставка: {{ (inputInvoice?.backMoney + ' грн') || '0' }}</span>
          </div>
          <div class="invoice-services__text nowrap-text" *ngIf="inputInvoice?.Cash2CardPAN === ''">
            <span>• Вартість комісії: {{ paymentSum + ' грн' }}&nbsp;</span>
          </div>
          <div class="invoice-services__text nowrap-text">• Платник за
                                                          комісію: {{ commissionPayer }}
          </div>
          <div class="invoice-services__text nowrap-text" *ngIf="type === 'out'">
            &nbsp;•&nbsp;Тип доставки: {{
              ((inputInvoice?.moneyTransferCash2Card)
                ? 'На картку ' + inputInvoice?.cardMaskedNumber
                : 'У відділення')
            }}
          </div>
        </div>

        <div class="invoice-services__item"
             *ngIf="!!inputInvoice.paymentControl">
          <i class="material-icons invoice-services__icon">reply</i>
          <span class="invoice-services__name">Контроль оплати:
            {{ (inputInvoice.paymentControl) + ' грн' }}</span>
        </div>

        <div class="invoice-services__item"
             *ngIf="!!inputInvoice.AccompanyingDocuments">
          <div class="invoice-services__name d-flex w-100 nowrap-text align-items-center">
            <i class="material-icons invoice-services__icon">description</i>
            <span
              class="text-overflow-ellipsis">Супроводжуючі документи: {{ inputInvoice.AccompanyingDocuments }}</span>
          </div>
        </div>
      </div>

      <div class="invoice__payment">
        <div class="info-row invoice__row">
          <div class="info-row__left">
            <div class="info-row__col">
              <div class="info-cell info-row__cell delivery-cost">
                <div class="info-cell__label">Вартість доставки</div>

                <div *ngIf="invoice?.deliveryPrice !== invoice?.SumBeforeCheckWeight"
                     class="info-cell__content info-cell__content_lg">
                  <span class="line-through-text">{{ invoice?.SumBeforeCheckWeight }}</span>
                  {{ invoiceCost }}
                </div>

                <div *ngIf="invoice?.deliveryPrice === invoice?.SumBeforeCheckWeight
                         && !isPaid(paymentCostsInfo)
                         || invoice?.lastCreatedOnTheBasisDocumentType"
                     class="info-cell__content info-cell__content_lg">
                  {{ invoiceCost }}
                </div>

                <div *ngIf="invoice?.deliveryPrice === invoice?.SumBeforeCheckWeight
                           && (paymentCostsInfo && isPaid(paymentCostsInfo))
                           && !invoice?.lastCreatedOnTheBasisDocumentType"
                     class="info-cell__content info-cell__content_lg payment-status-cell">
                  <div [class.line-through-text]="!hideIsPaid">
                    {{ invoiceCost }}
                  </div>
                  <ng-container *ngIf="!hideIsPaid">Сплачено</ng-container>
                </div>
              </div>
            </div>

            <div class="info-row__col">
              <div class="info-cell info-row__cell">
                <div class="info-cell__label">Платник за доставку</div>
                <div class="info-cell__content">
                  {{ payerNameTranslationsShort[invoice?.payer] }}
                </div>
              </div>
            </div>

            <ng-container *ngIf="isMobile$ | async">
              <div class="info-row__col">
                <ng-container
                  *ngTemplateOutlet="paymentType; context: { label: 'Форма оплати за доставку', content: invoice?.paymentMethod?.id || invoice?.PaymentMethod }">
                </ng-container>
              </div>
            </ng-container>
          </div>

          <!--          region paymentType template  -->
          <ng-template #paymentType
                       let-label="label"
                       let-content="content">
            <div class="info-cell info-row__cell">
              <div class="info-cell__label">
                {{ label }}
              </div>
              <div *ngIf="content; else dashContent"
                   class="info-cell__content">
                {{ paymentMethodTranslations[content] }}
              </div>
            </div>
          </ng-template>

          <ng-template #dashContent>
            <div class="info-cell__content">—</div>
          </ng-template>
          <!--          endregion paymentType template  -->

          <div class="info-row__right">
            <ng-container *ngIf="isDesktop$ | async">
              <ng-container
                *ngTemplateOutlet="paymentType; context: { label: 'Форма оплати за доставку', content: invoice?.paymentMethod?.id || invoice?.PaymentMethod }">
              </ng-container>
            </ng-container>

            <div
              [matTooltip]="!paymentCostsInfo || (paymentCostsInfo && isPaid(paymentCostsInfo)) || paymentCostsInfo?.UseNovaPay === null || inputInvoice?.ExpressWaybillPaymentStatus === ExpressWaybillPaymentStatus.PaymentNotAvailable ? 'Оплата недоступна' : null"
              class="payment-btn-left"
              matTooltipPosition="below">
              <button *ngIf="(type === 'in' || type === 'out') &&
                      !inputInvoice?.isInternational &&
                      ((inputInvoice?.recipient?.phone || inputInvoice?.sender?.phone) || (invoice?.PhoneSender || invoice?.PhoneRecipient))"
                      class="mat-button_sm mat-button_uppercase invoice__payment-btn"
                      (click)="createPayment(invoice, type)"
                      [disabled]="checkPaymentDisabled()"
                      color="primary"
                      mat-raised-button>
                Сплатити
              </button>
              <button *ngIf="showPaymentButtonForInternationalInvoice()"
                      class="mat-button_sm mat-button_uppercase invoice__payment-btn"
                      (click)="createPayment(invoice, type)"
                      [disabled]="checkPaymentDisabled()"
                      color="primary"
                      mat-raised-button>
                Сплатити
              </button>
            </div>
          </div>
        </div>
      </div>

      <np-invoice-full-info-modal *ngIf="isShowFull"
                                  [invoice]="invoice"
                                  [invoiceFullData]="inputInvoice">
      </np-invoice-full-info-modal>
      <div class="invoice-return-info" *ngIf="!!(redirectRequest || returnRequest)">
        <div class="invoice-return-info__title" *ngIf="!!returnRequest">Повернення посилки</div>
        <div class="invoice-return-info__title" *ngIf="!!redirectRequest">Переадресування посилки</div>
        <div class="invoice-return-info__location">{{ newInvoice?.recipientAddress?.shortDescription }}</div>
        <button type="button"
                [disabled]="newInvoicePending$ | async"
                (click)="goToNewInvoice(redirectRequest?.newInvoiceNumber  || returnRequest?.newInvoiceNumber, $event)"
                class="mat-button_transparent matF-button_sm mat-button_uppercase invoice-return-info__btn"
                mat-button color="primary">
          Нова накладна {{ (redirectRequest?.newInvoiceNumber || returnRequest?.newInvoiceNumber)|fineDocNumber }}
        </button>
        <div class="invoice-return-info__total">Вартість
                                                доставки:
          {{
            newInvoice?.isInternational
              ? formatCostForInternationalInvoice(newInvoice?.deliveryPrice + newInvoice?.StoragePrice, newInvoice?.DocumentCostCurrencyCode)
              : (newInvoice?.deliveryPrice + newInvoice?.StoragePrice) + ' грн'
          }}
        </div>
      </div>
    </div>
  </main>
  <div class="modal-footer p-2">
    <div class="modal-footer-buttons">
      <div class="modal-footer-buttons__item">
        <button type="button"
                class="mat-button_with-icon"
                [disableRipple]="true" (click)="switchShowFull()"
                mat-button>
          <mat-icon *ngIf="!isShowFull" class="material-icons_grey button-more__icon">keyboard_arrow_down</mat-icon>
          <mat-icon *ngIf="isShowFull" class="material-icons_grey button-more__icon">keyboard_arrow_up</mat-icon>
          {{ !isShowFull ? 'Показати більше' : 'Приховати' }}
        </button>
      </div>
      <div class="modal-footer-buttons__item modal-footer-buttons__right">
        <app-donate-button></app-donate-button>
        <button mat-button (click)="copy(invoice)"
                *ngIf="(type === 'out' && (invoice?.docNumber.slice(0, 2)) === '20') || ((type === 'arch-main') && isPossibilityDuplicate); else showIntDuplicate">
          <mat-icon class="material-icons_grey"
                    *ngIf="invoice?.marketPlaceToken !== '005056b24375-ad0d-11e8-a601-05690e3b'"
                    [matTooltip]="'Дублювати'"
                    matTooltipPosition="below">file_copy
          </mat-icon>
        </button>

        <ng-template #showIntDuplicate>
          <button mat-button (click)="copyInternational(inputInvoice)"
                  [disabled]="pending$ | async"
                  *ngIf="inputInvoice?.IsPossibilityInternationalDuplicate && !!inputInvoice?.InternationalExpressWaybill">
            <mat-icon class="material-icons_grey"
                      [matTooltip]="'Дублювати міжнародну посилку'"
                      matTooltipPosition="below">file_copy
            </mat-icon>
          </button>
        </ng-template>

        <button mat-button [matMenuTriggerFor]="printMenu" [matTooltip]="'Друкувати'">
          <mat-icon class="material-icons_grey">print</mat-icon>
        </button>

        <mat-menu #printMenu="matMenu" class="mat-menu_width_3">
          <button mat-menu-item (click)="printOneCopy([invoice])">
            Експрес-накладну, 1 копiя
          </button>
          <button mat-menu-item (click)="print([invoice])">
            Експрес-накладну, 2 копiї
          </button>
        </mat-menu>
        <button mat-button
                *ngIf="inputInvoice?.possibilityCreateLightReturn && (type === 'in' || type === 'arch-main') "
                [disabled]="(lightReturnPending$ | async)"
                (click)="lightReturn()"
                [matTooltip]="'Легке повернення'"
                matTooltipPosition="below"
        >
          <mat-icon>subdirectory_arrow_left</mat-icon>
        </button>
        <button mat-button
                *ngIf="!currentStateIsArchived"
                class="mat-button_with-icon"
                [disabled]="currentStateIsArchived ||
                    ((invoice?.state.id !== '5') && ((inputInvoice?.statusCode !== '102') &&
                    (inputInvoice?.statusCode !== '103') && (inputInvoice?.statusCode !== '108'))) ||
                    (['2', '5', '1'].indexOf(invoice?.docNumber[0]) === -1)"
                [matTooltip]="'Архівувати'"
                matTooltipPosition="below"
                (click)="addDocumentToArchive(inputInvoice)">
          <mat-icon>archive</mat-icon>
        </button>
        {{ type }}
        <button
          mat-button
          *ngIf="(type === 'in' || type === 'out' || type === 'arch-main')"
          (click)="claim(invoice)"
          class="mat-button_with-icon"
        >
          <mat-icon class="material-icons_grey"
                    [matTooltip]="'Зафіксувати звернення'"
                    matTooltipPosition="below">flag
          </mat-icon>
        </button>
        <button mat-button [matMenuTriggerFor]="appMenu"
                *ngIf="inputInvoice.allowManageButton"
                class="mat-button_with-icon"
        >
          <mat-icon>swap_vertical_circle</mat-icon>
          Управління
        </button>
        <mat-menu #appMenu="matMenu" class="max-width-400">
          <button *ngIf="inputInvoice.possibilityCreateRedirecting" mat-menu-item
                  (click)="redirectInvoice(inputInvoice)">
            {{
              checkCanEdit(inputInvoice.OrderingAdditionalServices, 'Redirecting')
                ? "Редагування переадресації"
                : "Заявка на переадресацію"
            }}
          </button>
          <button *ngIf="inputInvoice.possibilityCreateReturn" mat-menu-item (click)="returnInvoice(inputInvoice)">
            {{
              checkCanEdit(inputInvoice.OrderingAdditionalServices, 'CargoReturn')
                ? "Редагування повернення"
                : "Заявка на повернення"
            }}
          </button>
          <button *ngIf="inputInvoice.possibilityChangeEW" mat-menu-item (click)="changeEw(inputInvoice)">
            Заявка на зміну даних
          </button>
          <button *ngIf="inputInvoice.possibilityTermExtension" mat-menu-item
                  (click)="changeCustomerReturn(inputInvoice)">
            Заявка на подовження терміну зберігання
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
<ng-template #dash>—</ng-template>
